import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import type {
  AccountInfo,
  Connection,
  ParsedAccountData,
  PublicKey,
} from "@solana/web3.js";

export async function findTokenAccountsByOwner(
  connection: Connection,
  owner: PublicKey | null
): Promise<{ pubkey: PublicKey; account: AccountInfo<ParsedAccountData> }[]> {
  if (!owner) {
    return [];
  }
  const result = await connection.getParsedTokenAccountsByOwner(owner, {
    programId: TOKEN_PROGRAM_ID,
  });
  return result.value;
}
